import React, { useCallback, useState } from "react";
import { Page, Card, Tabs } from "@shopify/polaris";

import PartnersInvite from "./components/partnersusers/partnersinvited";
import PartnersRegister from "./components/partnersusers/partnersregistered";
import store from "store-js";

export default function PartnersUser() {
  const currentTab = store.get("partnerTab") || 0;
  const [selected, setSelected] = useState(currentTab);
  store.set("partnerTab", selected);
  const handleTabChange = useCallback(
    (selectedTabIndex) => setSelected(selectedTabIndex),
    []
  );

  const tabs = [
    {
      id: "Invited",
      title: "Invited",
      content: "Invited",
      page: <PartnersInvite />,
      panelID: "Invited",
    },
    {
      id: "Registered",
      title: "Registered",
      content: "Registered",
      page: <PartnersRegister />,
      panelID: "Registered",
    },
  ];

  return (
    <Page
      breadcrumbs={[{ url: "/" }]}
      title={tabs[selected].id + " Partner Users"}
      fullWidth
    >
      <Card>
        <Tabs tabs={tabs} selected={selected} onSelect={handleTabChange}>
          {tabs[selected].page}
        </Tabs>
      </Card>
    </Page>
  );
}
